import "../../../define/i18n.js";
import { registerIcons } from "../../../icons/element/register/index.js";
import { airPlayEnterIcon } from "../../../icons/dist/html/neutral/airplay-enter.js";
import { airPlayExitIcon } from "../../../icons/dist/html/neutral/airplay-exit.js";
import { captionsOffIcon } from "../../../icons/dist/html/neutral/captions-off.js";
import { captionsOnIcon } from "../../../icons/dist/html/neutral/captions-on.js";
import { castEnterIcon } from "../../../icons/dist/html/neutral/cast-enter.js";
import { castExitIcon } from "../../../icons/dist/html/neutral/cast-exit.js";
import { checkIcon } from "../../../icons/dist/html/neutral/check.js";
import { chevronIcon } from "../../../icons/dist/html/neutral/chevron.js";
import { fullscreenEnterIcon } from "../../../icons/dist/html/neutral/fullscreen-enter.js";
import { fullscreenExitIcon } from "../../../icons/dist/html/neutral/fullscreen-exit.js";
import { gearIcon } from "../../../icons/dist/html/neutral/gear.js";
import { pauseIcon } from "../../../icons/dist/html/neutral/pause.js";
import { pipEnterIcon } from "../../../icons/dist/html/neutral/pip-enter.js";
import { pipExitIcon } from "../../../icons/dist/html/neutral/pip-exit.js";
import { playIcon } from "../../../icons/dist/html/neutral/play.js";
import { restartIcon } from "../../../icons/dist/html/neutral/restart.js";
import { speechIcon } from "../../../icons/dist/html/neutral/speech.js";
import { speedIcon } from "../../../icons/dist/html/neutral/speed.js";
import { spinnerIcon } from "../../../icons/dist/html/neutral/spinner.js";
import { switchesIcon } from "../../../icons/dist/html/neutral/switches.js";
import { volumeHighIcon } from "../../../icons/dist/html/neutral/volume-high.js";
import { volumeLowIcon } from "../../../icons/dist/html/neutral/volume-low.js";
import { volumeOffIcon } from "../../../icons/dist/html/neutral/volume-off.js";
import "../../../define/ui/container.js";
import "../../../define/ui/poster.js";
import "../../../define/ui/buffering-indicator.js";
import "../../../define/ui/error-dialog.js";
import "../../../define/ui/dialog-backdrop.js";
import "../../../define/ui/dialog-popup.js";
import "../../../define/ui/dialog-title.js";
import "../../../define/ui/dialog-description.js";
import "../../../define/ui/dialog-close.js";
import "../../../define/ui/title.js";
import "../../../define/ui/controls.js";
import "../../../define/ui/controls-backdrop.js";
import "../../../define/ui/controls-content.js";
import "../../../define/ui/tooltip-group.js";
import "../../../define/ui/controls-group.js";
import "../../../define/ui/airplay-button.js";
import "../../../define/ui/tooltip.js";
import "../../../define/ui/tooltip-label.js";
import "../../../define/ui/tooltip-shortcut.js";
import "../../../define/ui/cast-button.js";
import "../../../define/ui/pip-button.js";
import "../../../define/ui/fullscreen-button.js";
import "../../../define/ui/play-button.js";
import "../../../define/ui/time-slider.js";
import "../../../define/ui/time-slider-chapters.js";
import "../../../define/ui/slider-track.js";
import "../../../define/ui/slider-buffer.js";
import "../../../define/ui/slider-fill.js";
import "../../../define/ui/slider-thumb.js";
import "../../../define/ui/slider-preview.js";
import "../../../define/ui/slider-thumbnail.js";
import "../../../define/ui/slider-value.js";
import "../../../define/ui/time-slider-chapter-title.js";
import "../../../define/ui/mute-button.js";
import "../../../define/ui/volume-popover.js";
import "../../../define/ui/volume-slider.js";
import "../../../define/ui/time-group.js";
import "../../../define/ui/time.js";
import "../../../define/ui/time-separator.js";
import "../../../define/ui/captions-button.js";
import "../../../define/ui/menu.js";
import "../../../define/ui/menu-content.js";
import "../../../define/ui/menu-item.js";
import "../../../define/ui/menu-separator.js";
import "../../../define/ui/quality-radio-group.js";
import "../../../define/ui/menu-radio-item.js";
import "../../../define/ui/menu-item-indicator.js";
import "../../../define/ui/audio-track-radio-group.js";
import "../../../define/ui/playback-rate-radio-group.js";
import "../../../define/ui/captions-radio-group.js";
import "../../../define/ui/hotkey.js";
import "../../../define/ui/gesture.js";
import "../../../define/ui/status-announcer.js";
import "../../../define/ui/volume-indicator.js";
import "../../../define/ui/volume-indicator-fill.js";
import "../../../define/ui/volume-indicator-value.js";
import "../../../define/ui/status-indicator.js";
import "../../../define/ui/status-indicator-value.js";
import "../../../define/ui/seek-indicator.js";
import "../../../define/ui/seek-indicator-value.js";
//#region src/internal/skins/neutral-video/register.ts
registerIcons("neutral", {
	"airplay-enter": airPlayEnterIcon,
	"airplay-exit": airPlayExitIcon,
	"captions-off": captionsOffIcon,
	"captions-on": captionsOnIcon,
	"cast-enter": castEnterIcon,
	"cast-exit": castExitIcon,
	check: checkIcon,
	chevron: chevronIcon,
	"fullscreen-enter": fullscreenEnterIcon,
	"fullscreen-exit": fullscreenExitIcon,
	gear: gearIcon,
	pause: pauseIcon,
	"pip-enter": pipEnterIcon,
	"pip-exit": pipExitIcon,
	play: playIcon,
	restart: restartIcon,
	speech: speechIcon,
	speed: speedIcon,
	spinner: spinnerIcon,
	switches: switchesIcon,
	"volume-high": volumeHighIcon,
	"volume-low": volumeLowIcon,
	"volume-off": volumeOffIcon
});
//#endregion
